import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FormTextAreaField } from "../../components/form/text-area";
import axios from "axios";
import { url } from "../../config";
import moment from "moment";
import successToast from "../toast/successToast";
import errorToast from "../toast/errorToast";
import { MessageSquare, Send, User } from "lucide-react";

const CommentsComponent = ({ tableName, viewId }) => {
  const [data, setData] = useState(null);

  const initialValues = {
    comment: "",
  };

  const validationSchema = Yup.object().shape({
    comment: Yup.string().required("Required"),
  });

  const handleSubmit = (values, { resetForm }) => {
    console.log(values, "values");
    const token = localStorage.getItem("accessToken");

    axios
      .post(
        `${url}/ffadmin/create-comment`,
        {
          model_name: tableName,
          record_id: viewId,
          comment: values?.comment,
        },
        {
          headers: {
            "x-access-token": token,
          },
        },
      )
      .then((res) => {
        console.log(res.data, "res.data");
        successToast(res.message);
        commentsList();
        resetForm();
      })
      .catch((err) => {
        console.error("API Error:", err);
        errorToast(err?.response?.data?.message);
      });
  };

  const commentsList = () => {
    const token = localStorage.getItem("accessToken");

    axios
      .post(
        `${url}/ffadmin/list-comment`,
        {
          model_name: tableName,
          record_id: viewId,
        },
        {
          headers: {
            "x-access-token": token,
          },
        },
      )
      .then((res) => {
        console.log(res.data, "res.data");
        setData(res?.data?.data);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    commentsList();
  }, [tableName, viewId]);

  return (
    <div className="w-full">
      {/* Section Header */}
      <div className="flex items-center justify-between pb-4 mb-6 border-b border-slate-100">
        <div className="flex items-center gap-2.5">
          <div className="p-2 bg-indigo-50 text-primary rounded-lg">
            <MessageSquare className="w-4 h-4" />
          </div>
          <div>
            <h3 className="text-base font-bold text-slate-900 tracking-tight">
              Comments
            </h3>
            <p className="text-xs text-slate-400">
              {data ? `${data.length} responses` : "Activity thread"}
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {/* Comments Feed */}
        <div className="space-y-3.5 max-h-[28rem] overflow-y-auto pr-1">
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <div
                key={index}
                className="bg-slate-50/70 border border-slate-200/80 rounded-xl p-4 transition-all hover:bg-slate-50"
              >
                <div className="flex items-center justify-between gap-3 mb-2.5">
                  <div className="flex items-center gap-3">
                    {/* User Avatar with Fallback */}
                    {item?.ffAdminUser?.profile_picture ? (
                      <img
                        src={item?.ffAdminUser?.profile_picture}
                        alt={item?.ffAdminUser?.name || "User"}
                        className="w-8 h-8 rounded-full object-cover border border-slate-200 shadow-2xs"
                      />
                    ) : (
                      <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-700 font-bold text-xs flex items-center justify-center border border-indigo-200">
                        {item?.ffAdminUser?.name ? (
                          item.ffAdminUser.name.charAt(0).toUpperCase()
                        ) : (
                          <User className="w-4 h-4 text-indigo-500" />
                        )}
                      </div>
                    )}
                    <div>
                      <h4 className="text-xs font-bold text-slate-800 leading-tight">
                        {item?.ffAdminUser?.name || "Anonymous User"}
                      </h4>
                      <span className="text-[11px] text-slate-400 font-medium">
                        {moment(item?.createdAt).format("MMM D, YYYY • h:mm A")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="pl-11">
                  <p className="text-xs sm:text-sm text-slate-600 leading-relaxed whitespace-pre-line">
                    {item?.comment}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-8 px-4 border border-dashed border-slate-200 rounded-xl bg-slate-50/50">
              <p className="text-xs text-slate-400 font-medium">
                No comments yet. Start the conversation below!
              </p>
            </div>
          )}
        </div>

        {/* Comment Input Form */}
        <div className="pt-2">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ isSubmitting }) => (
              <Form className="space-y-3">
                <div className="relative">
                  <FormTextAreaField
                    label={""}
                    name={"comment"}
                    placeholder="Write a comment..."
                    rows={3}
                  />
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="flex items-center gap-2 text-xs md:text-sm font-semibold px-4 py-2 bg-primary hover:bg-indigo-700 disabled:opacity-50 text-white rounded-xl shadow-xs transition-all active:scale-95"
                  >
                    <Send className="w-3.5 h-3.5" />
                    Submit Comment
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default CommentsComponent;
